var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Email_Icon",
    "data-name": "Email Icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 44,
    height: 44.77,
    viewBox: "0 0 44 44.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1718",
    "data-name": "Rectangle 1718",
    width: 25.229,
    height: 17.467,
    transform: "translate(0 0)",
    fill: "none"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3031",
    "data-name": "Path 3031",
    d: "M0,22.385A22.2,22.2,0,0,1,22,0,22.2,22.2,0,0,1,44,22.385,22.2,22.2,0,0,1,22,44.77,22.2,22.2,0,0,1,0,22.385",
    fill: "#164295"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_590",
    "data-name": "Group 590",
    transform: "translate(9.385 13.652)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3039",
    "data-name": "Path 3039",
    d: "M25.023,2.476,18.5,9.146a.118.118,0,0,0,0,.167l0,0,4.566,4.878a.791.791,0,1,1-1.09,1.145l-.026-.026L17.4,10.448a.124.124,0,0,0-.176,0l-1.11,1.132a4.877,4.877,0,0,1-3.477,1.478,4.973,4.973,0,0,1-3.554-1.514L8.014,10.452a.124.124,0,0,0-.176,0L3.287,15.317A.791.791,0,0,1,2.171,14.2L6.738,9.323a.13.13,0,0,0,0-.168L.206,2.476a.12.12,0,0,0-.169,0A.116.116,0,0,0,0,2.56V15.907a1.949,1.949,0,0,0,1.941,1.948H23.288a1.949,1.949,0,0,0,1.941-1.948V2.562a.12.12,0,0,0-.122-.12.122.122,0,0,0-.084.034",
    transform: "translate(0 -0.388)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3040",
    "data-name": "Path 3040",
    d: "M12.75,10.827a3.348,3.348,0,0,0,2.376-.966L24.655.414A1.943,1.943,0,0,0,23.452,0H2.054a1.929,1.929,0,0,0-1.2.414l9.53,9.447a3.348,3.348,0,0,0,2.369.966",
    transform: "translate(-0.135 0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/EmailIcon.41828e3fa2e5166f92473225495b2d43.svg";
export { ForwardRef as ReactComponent };